import { getFeedsData } from '../../../datafetchers/HomePage';
import { fireFilterEvent } from '../../TopicListing/common';
import { FilterListDiv } from '../../TopicListing/styled';

export default function CommunityFilterList(props) {
  const { filterData, showLoader, setSelectedFilterId, mutate, indexToShow } =
    props;
  const fetchFilterData = async (termId, name) => {
    showLoader(true);
    const recentlyAskedParams = {
      filter: 'post',
      page: 0,
      tag: termId,
    };
    getFeedsData(recentlyAskedParams).then((response) => {
      const data = {
        questionItemData: response?.data?.posts,
        indexToShow: indexToShow,
      };
      mutate(data, false);
      setSelectedFilterId(termId);
      showLoader(false);
      fireFilterEvent(name, 'Filter By Stage');
    });
  };
  return (
    <>
      {filterData?.items?.map((data, index) => {
        return (
          <FilterListDiv key={index}>
            <input
              type="radio"
              id={`${data?.tagData?.term_id}${index}`}
              name="topicListing"
              defaultChecked={false}
              className="custom_radio"
              onChange={() =>
                fetchFilterData(
                  data?.tagData?.term_id,
                  data?.tagData?.description,
                )
              }
            />
            <label
              htmlFor={`${data?.tagData?.term_id}${index}`}
              className="custom_label"
            >
              {data?.tagData?.description}
            </label>
          </FilterListDiv>
        );
      })}
    </>
  );
}
